import './index.css'
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Favoritos(){

    const [filmes, setFilmes] = useState([])

    useEffect(()=>{
        const minhaLista = localStorage.getItem('@primeFlix')
        setFilmes(JSON.parse(minhaLista) || []);

    }, [])

    function excluirFilme(id){
       let filtroFilmes = filmes.filter((item)=>{
        return(item.id !== id) 
        
       })
       setFilmes(filtroFilmes)
       localStorage.setItem('@primeFlix', JSON.stringify(filtroFilmes))

    }
    return(
    <div>
        <h1>Meus Filmes</h1>
        <ul key={filmes.id} className='favoritocard'>
         {filmes.map((item)=>{
           return(
            <li key={item.id}>
              <span>{item.title}</span>

              <div className='botoesFav'>
               <Link to={`/filme/${item.id}`}> Ver detalhes</Link>
               <button onClick={() => excluirFilme(item.id)}>Excluir</button>
              </div>
            </li>
           )
         })}
        </ul>
    </div>
    )
}

export default Favoritos;